import React from "react";
import styles from "./styles.module.scss";

function SearchIcon() {
  return (
    <div>
      <img
        className={styles.search}
        src="https://advertflair-public.s3.us-west-2.amazonaws.com/assets/icons/search.svg"
        alt=""
      />
    </div>
  );
}

export default SearchIcon;
